
const STORE_BACKEND_BASE_URL = 'https://cron.loveinfaith.work/store-backend-staging/subscription';
const STORE_MONTHE_FULL_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const STORE_WEEK_FULL_NAMES = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
const StripeAPIKey = 'pk_live_51K0fKkFp4jpTrnv3BV0Z0wUsTbn8GT5NSPAWj2JUWWoWjsEySp6EoLHUKsTtzDcIAr7a1BcZYkfej6mBqZF6osJF00fklyuddu';

document.addEventListener('alpine:init', () => {
  Alpine.data('userSubscriptions', () => ({
    selectedSubscriptionId: null,
    subscriptions: {},
    isLoaded: false,
    paymentMethod: null,
    skipAMonthStart: false,
    cancelSubscriptionStart: false,
    cancelSubscriptionSurveyStart: false,
    activateSubscriptionStart: false,
    reactivateSubscriptionStart: false,
    successMessage: null,
    errorMessage: null,
    customerInfo: window.__LIF__.customer_info,
    editType: null,

    get basicCustomerInfo() {
      const utmCookies = getLifCookie('_shopify_sa_p');
      return {
        shopify_customer_email: this.customerInfo.email,
        shopify_customer_phone: this.customerInfo.phone,
        shopify_customer_id: this.customerInfo.id,
        utm_parameters: utmCookies ? decodeURIComponent(utmCookies) : '',
      };
    },

    get selectedSubscriptionIsActive() {
      return this.subscriptions.active && !!this.subscriptions.active.find((s) => s.id == this.selectedSubscriptionId);
    },

    init() {

      /* Test dummy to avoid fetch every time -- DUMMY*/
      // const res = '{"subscriptions":{"active":[{"id":"683hns5846uX","real_id":521230350,"customer_id":"68vlmMx45KY=","product_title":"BibleBox","variant_title":"S","product_id":6632442036291,"shopify_variant_id":39682697953347,"price":24.95,"status":"ACTIVE","address_id":"78jjnc156K+V","address_details":{"payment_method_id":148407557,"payment_method":{"id":148407557,"customer_id":54541448,"billing_address":{"address1":"6475 East Pacific Coast Highway #1013","address2":null,"city":"Long Beach","company":null,"country":"United States","country_code":"US","first_name":"Zack","last_name":"Williams","phone":"+19099922770","province":"California","zip":"90803"},"created_at":"2024-08-13T18:47:46+00:00","default":true,"include":[],"payment_details":{"brand":"Mastercard","exp_month":1,"exp_year":2028,"last4":"8730"},"payment_type":"SHOP_PAY","processor_customer_token":"2819949461571","processor_name":"shopify_payments","processor_payment_method_token":"gid:\/\/shopify\/CustomerPaymentMethod\/5f93735b29eef78b2132adc874c5e1f3","status":"valid","status_reason":null,"updated_at":"2024-08-13T18:50:41+00:00"},"first_name":"Zack","last_name":"Williams TEST","address1":"4011 East 1st Street","address2":"Apt 1 TEST","city":"Long Beach","province":"California","zip":"90804","country":"US","phone":"+19099922770"},"variants":[{"id":39682697953347,"product_id":6632442036291,"title":"S","price":"24.95","position":1,"inventory_policy":"continue","compare_at_price":"24.95","option1":"S","option2":null,"option3":null,"created_at":"2021-12-16T09:31:06-08:00","updated_at":"2024-09-06T00:32:47-07:00","taxable":true,"barcode":"","fulfillment_service":"manual","grams":363,"inventory_management":"shopify","requires_shipping":true,"sku":"BB0001","weight":0.8,"weight_unit":"lb","inventory_item_id":41779094224963,"inventory_quantity":-3735,"old_inventory_quantity":-3735,"tax_code":"PC040100","admin_graphql_api_id":"gid:\/\/shopify\/ProductVariant\/39682697953347","image_id":28969388343363},{"id":39682697986115,"product_id":6632442036291,"title":"M","price":"24.95","position":2,"inventory_policy":"continue","compare_at_price":"24.95","option1":"M","option2":null,"option3":null,"created_at":"2021-12-16T09:31:06-08:00","updated_at":"2024-09-06T00:11:36-07:00","taxable":true,"barcode":"","fulfillment_service":"manual","grams":363,"inventory_management":"shopify","requires_shipping":true,"sku":"BB0002","weight":0.8,"weight_unit":"lb","inventory_item_id":41779094257731,"inventory_quantity":-7932,"old_inventory_quantity":-7932,"tax_code":"PC040100","admin_graphql_api_id":"gid:\/\/shopify\/ProductVariant\/39682697986115","image_id":28969388343363},{"id":39682698018883,"product_id":6632442036291,"title":"L","price":"24.95","position":3,"inventory_policy":"continue","compare_at_price":"24.95","option1":"L","option2":null,"option3":null,"created_at":"2021-12-16T09:31:06-08:00","updated_at":"2024-09-06T00:41:35-07:00","taxable":true,"barcode":"","fulfillment_service":"manual","grams":363,"inventory_management":"shopify","requires_shipping":true,"sku":"BB0003","weight":0.8,"weight_unit":"lb","inventory_item_id":41779094290499,"inventory_quantity":-13987,"old_inventory_quantity":-13987,"tax_code":"PC040100","admin_graphql_api_id":"gid:\/\/shopify\/ProductVariant\/39682698018883","image_id":28969388343363},{"id":39682698051651,"product_id":6632442036291,"title":"XL","price":"24.95","position":4,"inventory_policy":"continue","compare_at_price":"24.95","option1":"XL","option2":null,"option3":null,"created_at":"2021-12-16T09:31:06-08:00","updated_at":"2024-09-06T00:41:36-07:00","taxable":true,"barcode":"","fulfillment_service":"manual","grams":363,"inventory_management":"shopify","requires_shipping":true,"sku":"BB0004","weight":0.8,"weight_unit":"lb","inventory_item_id":41779094323267,"inventory_quantity":-16104,"old_inventory_quantity":-16104,"tax_code":"PC040100","admin_graphql_api_id":"gid:\/\/shopify\/ProductVariant\/39682698051651","image_id":28969388343363},{"id":39682698084419,"product_id":6632442036291,"title":"2X","price":"24.95","position":5,"inventory_policy":"continue","compare_at_price":"24.95","option1":"2X","option2":null,"option3":null,"created_at":"2021-12-16T09:31:06-08:00","updated_at":"2024-09-06T00:41:35-07:00","taxable":true,"barcode":"","fulfillment_service":"manual","grams":363,"inventory_management":"shopify","requires_shipping":true,"sku":"BB0005","weight":0.8,"weight_unit":"lb","inventory_item_id":41779094356035,"inventory_quantity":-11484,"old_inventory_quantity":-11484,"tax_code":"PC040100","admin_graphql_api_id":"gid:\/\/shopify\/ProductVariant\/39682698084419","image_id":28969388343363},{"id":39682698117187,"product_id":6632442036291,"title":"3X","price":"24.95","position":6,"inventory_policy":"continue","compare_at_price":"24.95","option1":"3X","option2":null,"option3":null,"created_at":"2021-12-16T09:31:06-08:00","updated_at":"2024-09-05T14:12:12-07:00","taxable":true,"barcode":"","fulfillment_service":"manual","grams":363,"inventory_management":"shopify","requires_shipping":true,"sku":"BB0006","weight":0.8,"weight_unit":"lb","inventory_item_id":41779094388803,"inventory_quantity":-7158,"old_inventory_quantity":-7158,"tax_code":"PC040100","admin_graphql_api_id":"gid:\/\/shopify\/ProductVariant\/39682698117187","image_id":28969388343363},{"id":39889951981635,"product_id":6632442036291,"title":"4X","price":"24.95","position":7,"inventory_policy":"continue","compare_at_price":"24.95","option1":"4X","option2":null,"option3":null,"created_at":"2022-04-06T13:48:49-07:00","updated_at":"2024-09-06T00:11:37-07:00","taxable":true,"barcode":"","fulfillment_service":"manual","grams":363,"inventory_management":"shopify","requires_shipping":true,"sku":"BB0007","weight":0.8,"weight_unit":"lb","inventory_item_id":41986695168067,"inventory_quantity":-1544,"old_inventory_quantity":-1544,"tax_code":"PC040100","admin_graphql_api_id":"gid:\/\/shopify\/ProductVariant\/39889951981635","image_id":28969388343363}],"created_at":"2024-08-13T14:50:42","charge_interval_frequency":"1","order_interval_frequency":"1","order_interval_unit":"month","source":"RECHARGE","next_charge_scheduled_at":{"month":"9\/2024","date":5}},{"id":"n8fmlb946afheQ==","real_id":"A869B499FF","customer_id":"6szllMk=","product_id":"50","product_title":"LiF Membership Program","variant_title":"L","price":"9.95","next_charge_scheduled_at":{"month":"9\/2024","date":4},"status":"PAUSED","variants":[{"id":"321","option1":"S"},{"id":"322","option1":"M"},{"id":"323","option1":"L"},{"id":"324","option1":"XL"},{"id":"325","option1":"2X"},{"id":"326","option1":"3X"},{"id":"5103","option1":"4X"}],"created_at":"2023-06-01 16:19:40","charge_interval_frequency":30,"order_interval_unit":"days","source":"CC","address_details":{"first_name":"Zack","last_name":"Williams","address1":"YY4011 E 1st St Apt 1","address2":null,"city":"Long Beach","province":"CA","zip":"90803","country":"US","phone":"9099922770"}}],"inactive":[{"id":"683hns5846qe","real_id":521230349,"customer_id":"68vlmMx45KY=","product_title":"BibleBox","variant_title":"S","product_id":6632442036291,"shopify_variant_id":39682697953347,"price":24.95,"status":"CANCELLED","address_id":"78jjnc156K+V","address_details":{"payment_method_id":148407557,"payment_method":{"id":148407557,"customer_id":54541448,"billing_address":{"address1":"6475 East Pacific Coast Highway #1013","address2":null,"city":"Long Beach","company":null,"country":"United States","country_code":"US","first_name":"Zack","last_name":"Williams","phone":"+19099922770","province":"California","zip":"90803"},"created_at":"2024-08-13T18:47:46+00:00","default":true,"include":[],"payment_details":{"brand":"Mastercard","exp_month":1,"exp_year":2028,"last4":"8730"},"payment_type":"SHOP_PAY","processor_customer_token":"2819949461571","processor_name":"shopify_payments","processor_payment_method_token":"gid:\/\/shopify\/CustomerPaymentMethod\/5f93735b29eef78b2132adc874c5e1f3","status":"valid","status_reason":null,"updated_at":"2024-08-13T18:50:41+00:00"},"first_name":"Zack","last_name":"Williams TEST","address1":"4011 East 1st Street","address2":"Apt 1 TEST","city":"Long Beach","province":"California","zip":"90804","country":"US","phone":"+19099922770"},"variants":[],"created_at":"2024-08-13T14:50:42","charge_interval_frequency":"1","order_interval_frequency":"1","order_interval_unit":"month","source":"RECHARGE","next_charge_scheduled_at":""},{"id":"6s7in8l84q6W","real_id":412340201,"customer_id":"68vlmMx45KY=","product_title":"LiF Sticker Club","variant_title":"5 Stickers Per Month","product_id":6653721247811,"shopify_variant_id":39766586785859,"price":5.95,"status":"CANCELLED","address_id":"783pnch\/5q2U","address_details":{"payment_method_id":102519087,"payment_method":{"id":102519087,"customer_id":54541448,"billing_address":{"address1":"6475 East Pacific Coast Highway #1013","address2":null,"city":"Long Beach","company":null,"country":"United States","country_code":"US","first_name":"Zack","last_name":"Williams","phone":null,"province":"California","zip":"90803"},"created_at":"2023-09-13T22:43:08+00:00","default":false,"include":[],"payment_details":{"brand":"visa","exp_month":11,"exp_year":2025,"last4":"4137"},"payment_type":"CREDIT_CARD","processor_customer_token":"cus_N3zCwtUiZ6JCJw","processor_name":"stripe","processor_payment_method_token":"card_1Nq1m2Fp4jpTrnv3480fBSbq","status":"valid","status_reason":null,"updated_at":"2023-10-13T20:53:03+00:00"},"first_name":"Cancel","last_name":"Cancel","address1":"4011 E 1st ST","address2":null,"city":"Long beach","province":"CA","zip":"90803","country":"US","phone":null},"variants":[],"created_at":"2023-10-04T17:42:59","charge_interval_frequency":"1","order_interval_frequency":"1","order_interval_unit":"month","source":"RECHARGE","next_charge_scheduled_at":""},{"id":"5smS6MgNltyXCg==","real_id":"86BD5AFB05","customer_id":"6w==","product_id":"50","product_title":"LiF Membership Program","variant_title":"LiF Membership","price":"24.95","next_charge_scheduled_at":"","status":"CANCELLED","variants":[{"id":"321","option1":"S"},{"id":"322","option1":"M"},{"id":"323","option1":"L"},{"id":"324","option1":"XL"},{"id":"325","option1":"2X"},{"id":"326","option1":"3X"},{"id":"5103","option1":"4X"}],"created_at":"2022-06-14 16:28:44","charge_interval_frequency":30,"order_interval_unit":"days","source":"CC","address_details":{"first_name":"Zack","last_name":"Williams","address1":"4011 E 1st St Apt 1","address2":null,"city":"Long Beach","province":"CA","zip":"90803","country":"US","phone":"9099922770"}}]},"payment_method":{"recharge":{"id":148407557,"customer_id":54541448,"billing_address":{"address1":"6475 East Pacific Coast Highway #1013","address2":null,"city":"Long Beach","company":null,"country":"United States","country_code":"US","first_name":"Zack","last_name":"Williams","phone":"+19099922770","province":"California","zip":"90803"},"created_at":"2024-08-13T18:47:46+00:00","default":true,"include":[],"payment_details":{"brand":"Mastercard","exp_month":1,"exp_year":2028,"last4":"8730"},"payment_type":"SHOP_PAY","processor_customer_token":"2819949461571","processor_name":"shopify_payments","processor_payment_method_token":"gid:\/\/shopify\/CustomerPaymentMethod\/5f93735b29eef78b2132adc874c5e1f3","status":"valid","status_reason":null,"updated_at":"2024-08-13T18:50:41+00:00"},"cc":{"paySourceId":7715,"IsPrimary":"1","paySourceType":"CREDITCARD","cardType":"MASTERCARD","cardLast4":"8730","cardYear":"2028","cardMonth":"01","cardExpiryDate":"2028-01-31","achRoutingNumber":"","achAccountType":"","achBankName":"","achLast4":""}}}';
      // const r = JSON.parse(res);
      // this.subscriptions = r.subscriptions;
      // this.paymentMethod = r.payment_method;
      // this.isLoaded = true;
      
      
      this.loadSubscriptions();

      // On focus on strip payment input field mobile is auto zooming, to restrict this add below viewport content
      const viewport = document.querySelector("meta[name=viewport]");
      const viewportContent = viewport.getAttribute('content');

      if (!viewportContent.includes('maximum-scale=1.0')) {
        viewport.setAttribute('content', viewportContent+',maximum-scale=1.0,user-scalable=0');
      }

      this.$watch('successMessage', () => {
        setTimeout(() => {
          this.successMessage = null;
        }, 10000);
      });

      this.$watch('errorMessage', () => {
        setTimeout(() => {
          this.errorMessage = null;
        }, 10000);
      });

      this.$watch('cancelSubscriptionStart', (isStart) => {
        Alpine.store('screen').isScrollableBody = !isStart;
      });

      this.$watch('cancelSubscriptionSurveyStart', (isStart) => {
        Alpine.store('screen').isScrollableBody = !isStart;
      });
      
      this.$watch('skipAMonthStart', (isStart) => {
        Alpine.store('screen').isScrollableBody = !isStart;
      });

      this.$watch('editType', (type) => {
        Alpine.store('screen').isScrollableBody = (type == null || type == 'PaymentInfo');
      });
    },

    loadSubscriptions() {
      this.subscriptions = {};
      this.paymentMethod = null;
      this.isLoaded = false;

      fetch(`${STORE_BACKEND_BASE_URL}/list?emailId=${this.customerInfo.email}`)
      .then((r) => r.json())
      .then((r) => {
        this.subscriptions = r.subscriptions;
        this.paymentMethod = r.payment_method;
        this.isLoaded = true;
      })
      .catch((error) => {
        console.error(error);
      });
    },

    sendSkipAMonth() {
      const subscription = this.subscriptions.active.find((s) => s.id == this.selectedSubscriptionId);

      this.isLoaded = false;

      if (subscription) {
        fetch(`${STORE_BACKEND_BASE_URL}/skipAMonth`, {
          method: 'POST',
          body: JSON.stringify({
            customer_info: this.basicCustomerInfo,
            subscription_id: subscription.id,
            subscription_title: subscription.product_title,
            shopify_customer_id: this.customerInfo.id,
            source: subscription.source,
          })
        })
        .then((r) => r.json())
        .then((res) => {
          if (res.status == 'success') {
            this.subscription.next_charge_scheduled_at = res.data.next_charge_scheduled_at;

            const { month: monthYear, date } = this.subscription.next_charge_scheduled_at;
            const [month, year] = monthYear.split('/');
            const nextChargeDate = new Date(`${year}-${parseInt(month) + 1}-${date}`);
            const dayIndex = nextChargeDate.getDay();            

            this.successMessage = 'Next Payment has been skipped. Next order date is now '+STORE_WEEK_FULL_NAMES[dayIndex]+', '+this.orderOnDate;
          } else {
            this.errorMessage = 'Error while skipping month!';
          }

          this.isLoaded = true;
          this.skipAMonthStart = false;
          this.cancelSubscriptionStart = false;
        });
      }
    },

    cancelSubscription() {
      const subscription = this.subscriptions.active.find((s) => s.id == this.selectedSubscriptionId);

      this.isLoaded = false;
      if (subscription) {
        fetch(`${STORE_BACKEND_BASE_URL}/cancelSubscription`, {
          method: 'POST',
          body: JSON.stringify({
            customer_info: this.basicCustomerInfo,
            subscription_id: subscription.id,
            source: subscription.source,
          })
        })
        .then((r) => r.json())
        .then((res) => {
          if (res.status == 'success') {
            // console.log(res);
            this.successMessage = 'Subscription cancelled successfully.';

            this.selectedSubscriptionId = null;
            this.loadSubscriptions();
          } else {
            this.errorMessage = 'Error while cancelling subscription!';
          }
        });

        this.cancelSubscriptionStart = false;
      }
    },

    activateSubscription() {
      const subscription = this.subscriptions.inactive.find((s) => s.id == this.reactivateSubscriptionStart);

      if (subscription) {
        this.isLoaded = false;
        this.reactivateSubscriptionStart = null;

        fetch(`${STORE_BACKEND_BASE_URL}/reactivate`, {
          method: 'POST',
          body: JSON.stringify({
            customer_info: this.basicCustomerInfo,
            subscription_id: subscription.id,
            product_title: subscription.product_title,
            source: subscription.source,
            status: subscription.status,
          })
        })
        .then((r) => r.json())
        .then((res) => {
          if (res.status == 'success') {
            // console.log(res);
            this.successMessage = 'Subscription activated successfully.';

            this.selectedSubscriptionId = null;
            this.loadSubscriptions();
          } else {
            this.errorMessage = 'Error while activating subscription!';
          }
        });

        this.activateSubscriptionStart = null;
      } else {
        console.log('No subscription found.');
      }
    },

    productImageByTitle(title) {
      let thisSubscription = this.subscriptions.active.find((s) => s.product_title == title);
      if (!thisSubscription) {
        thisSubscription = this.subscriptions.inactive.find((s) => s.product_title == title);
      }
      return thisSubscription ? thisSubscription.product_image_url : '';
    }

  }));

  Alpine.data('subscription', (subscriptionId) => ({
    subscription: null,
    selectedSize: null,
    selectedShipmentDate: null,
    openSizeChart: false,
    currentlySelectedDate: null,

    init() {
      if (!this.subscriptions.active || !subscriptionId) {
        return null;
      }
      this.subscription = this.subscriptions.active.find((s) => s.id == subscriptionId);

      if (!this.subscription) {
        this.subscription = this.subscriptions.inactive.find((s) => s.id == subscriptionId);
      }

      this.selectedSize = this.shirtSize;
      this.selectedShipmentDate = this.subscription.next_charge_scheduled_at.date;
      this.currentlySelectedDate = this.subscription.next_charge_scheduled_at.date;
    },

    get orderOnDate() {
      if (!this.subscription) {
        return null;
      }
      if (!this.subscription.next_charge_scheduled_at) {
        return '';
      }

      const monthYear = this.subscription.next_charge_scheduled_at.month.split('/');
      return `${STORE_MONTHE_FULL_NAMES[monthYear[0]]} ${ordinalSuffixOf(
        this.subscription.next_charge_scheduled_at.date,
      )}`;
    },

    saveShipmentDate() {

      // Get current charge date
      const { month: monthYear, date } = this.subscription.next_charge_scheduled_at;
      const [month, year] = monthYear.split('/');
      const currentChargeDate = new Date(`${year}-${parseInt(month) + 1}-${date}`);
      // let now = new Date();
      
      // if (now.getDate() > this.selectedShipmentDate) {
      //   // Next month's date
      //   now = new Date(now.setMonth(now.getMonth() + 1));
      // }

      const orderOn = {
        month: `${currentChargeDate.getMonth()}/${currentChargeDate.getFullYear()}`,
        date: this.selectedShipmentDate,
      };

      const newOrderOn = `${STORE_MONTHE_FULL_NAMES[currentChargeDate.getMonth()]} ${ordinalSuffixOf(this.selectedShipmentDate)}`;

      this.isLoaded = false;

      const previousOrderOnDate = this.subscription.next_charge_scheduled_at;
      if (previousOrderOnDate.date !== orderOn.date || previousOrderOnDate.month !== orderOn.month) {
        fetch(`${STORE_BACKEND_BASE_URL}/updateOrderOnDate`, {
          method: 'POST',
          body: JSON.stringify({
            customer_info: this.basicCustomerInfo,
            subscription_id: this.subscription.id,
            source: this.subscription.source,
            order_on: orderOn,
            original_value: this.orderOnDate,
            new_value: newOrderOn,
          })
        })
        .then((r) => r.json())
        .then((res) => {
          if (res.status == 'success') {
            this.successMessage = 'Next shipment date updated successfully.';

            this.subscription.next_charge_scheduled_at = orderOn;
          } else {
            this.errorMessage = 'Shipment date failed to update!';
          }
          this.isLoaded = true;
        });
      } else {
        this.successMessage = 'Next shipment date updated successfully.';
        this.isLoaded = true;
      }

      this.editType = null;
    },
    get renewDate() {
      if (!this.subscription) {
        return null;
      }

      const { month: nextChangeMonth, date } = this.subscription.next_charge_scheduled_at;

      if (!nextChangeMonth) {
        return '';
      }
      const [month, year] = nextChangeMonth.split('/');

      return `${STORE_MONTHE_FULL_NAMES[parseInt(month)]} ${date}, ${year}`;
    },

    get paymentBrandName() {
      if (!this.subscription || !this.paymentMethod) {
        return null;
      }

      if (this.subscription.source === 'RECHARGE') {
        return this.subscription.address_details.payment_method.payment_details.brand;
      }

      return this.paymentMethod.cc.cardType;
    },
    get cardNumber() {
      if (!this.subscription || !this.paymentMethod) {
        return null;
      }

      let last4 = null;

      if (this.subscription.source === 'RECHARGE') {
        const paymentData = this.subscription.address_details.payment_method.payment_details;
        last4 = paymentData.last4;
      } else {
        const paymentData = this.paymentMethod.cc;
        last4 = paymentData.cardLast4;
      }

      return last4;
    },
    get paymentDetails() {
      if (!this.subscription || !this.paymentMethod) {
        return null;
      }

      let last4 = null;
      let expMonth = null;
      let expYear = null;

      if (this.subscription.source === 'RECHARGE') {
        const paymentData = this.subscription.address_details.payment_method.payment_details;
        last4 = paymentData.last4;
        expMonth = paymentData.exp_month;
        expYear = paymentData.exp_year;
      } else {
        const paymentData = this.paymentMethod.cc;
        last4 = paymentData.cardLast4;
        expMonth = paymentData.cardMonth;
        expYear = paymentData.cardYear;
      }
      const paymentMethodParts = [];
      paymentMethodParts.push(`Ending in ${last4}`);
      paymentMethodParts.push(`Expiration date: ${expMonth} / ${expYear}`);

      return paymentMethodParts.filter((a) => a).join('<br/>');
    },
    get notAMemberShipProduct() {
      return this.subscription && !this.subscription.product_title.includes('Membership');
    },
    get productTypeClass() {
      if (!this.subscription) {
        return null;
      }

      let productType = 'bibleBox';

      if (this.subscription.product_title.includes('BibleBox')) {
        productType = 'bibleBox';
      }

      if (this.subscription.product_title.includes('Sticker')) {
        productType = 'sticker';
      }

      if (this.subscription.product_title.includes('Membership')) {
        productType = 'membership';
      }

      return productType;
    },
    get sizes() {
      if (!this.subscription || !this.subscription.variants) {
        return null;
      }
      const shirtSizes = this.subscription.variants.map((v) => v.option1);
      return [...new Set(shirtSizes)];
    },
    get shirtSize() {
      if (!this.subscription) {
        return null;
      }

      const variantTitleParts = this.subscription.variant_title.split('/');
      if (variantTitleParts.length > 0) {
        const sizeCode = variantTitleParts[0].trim();

        return sizeCode;
      }

      return '';
    },
    get shirtSizeLabel() {
      const sizeList = {
        'S': 'Small',
        'M': 'Medium',
        'L': 'Large',
      };

      return sizeList[this.shirtSize] ? sizeList[this.shirtSize] : this.shirtSize;
    },
    get selectedSizeLabel() {
      const sizeList = {
        'S': 'Small',
        'M': 'Medium',
        'L': 'Large',
      };

      return sizeList[this.selectedSize] ? sizeList[this.selectedSize] : this.selectedSize;
    },
    get shippingCustomerName() {
      if (!this.subscription) {
        return null;
      }

      const address = this.subscription.address_details;
      return `${address.first_name} ${address.last_name}`;
    },
    get shippingAddress() {

      if (!this.subscription) {
        return null;
      }

      const addressParts = [];
      const address = this.subscription.address_details;
      addressParts.push(address.address1);
      addressParts.push(address.address2);
      addressParts.push(`${address.city} ${address.province} ${address.zip}`);

      return addressParts.filter((a) => a).join('<br/>');
    },
    saveSize() {

      this.isLoaded = false;
      const successMessage = 'Shirt size has been updated.';

      const selectedVariant = this.subscription.variants.find((v) => v.option1 == this.selectedSize)

      // Check if no update made
      if (this.shirtSize == this.selectedSize) {
        this.isLoaded = true;
        this.editType = null;
        this.successMessage = successMessage;
        return;
      }

      fetch(`${STORE_BACKEND_BASE_URL}/updateSize`, {
        method: 'POST',
        body: JSON.stringify({
          customer_info: this.basicCustomerInfo,
          subscription_id: this.subscription.id,
          variant_id: selectedVariant.id,
          product_id: this.subscription.product_id,
          source: this.subscription.source,
          original_value: this.shirtSize,
          new_value: this.selectedSize,
        })
      })
      .then((r) => r.json())
      .then((res) => {
        if (res.status == 'success') {
          this.successMessage = successMessage;

          // Set updated value
          const { subscription: updatedsubscription } = res.data;
          this.subscription.variant_title = updatedsubscription.variant_title;
        } else {
          this.errorMessage = 'Size failed to update.';
        }

        this.isLoaded = true;
      });

      this.editType = null;
    },
  }));

  Alpine.data('ccPayment', () => ({
    cardHolder: null,
    cardNumber: null,
    expDate: null,
    cvv: null,
    zipCode: null,
    cardValidationError: null,
    
    get saveButttonEnabled() {
      return this.cardNumber && this.expDate && this.cvv;
    },
    closeEdit() {
      this.editType = null;
      this.resetForm();
    },

    resetForm() {
      this.cardHolder = null;
      this.cardNumber = null,
      this.expDate = null,
      this.cvv = null,
      this.zipCode = null;
      this.cardValidationError = null;
    },

    get cardDetails() {
      return {
        cardHolder: this.cardHolder,
        cardNumber: this.cardNumber,
        expDate: this.expDate,
        cvv: this.cvv,
        zipCode: this.zipCode,
      }
    },

    async savePaymentInfo() {
      const validationErrors = {
        cardNumber: 'Cart Number is required.',
        expDate: 'Expiration Date is required.',
        cvv: 'CVV is required.',
      };

      for ([field, message] of Object.entries(validationErrors)) {
        // Check validation
        if (!this[field] || this[field].trim() == '') {
          this.cardValidationError = message;
          return;
        }
      }

      this.cardValidationError = null;

      const previousCardDetails = this.paymentMethod.cc;

      const res = await fetch(`${STORE_BACKEND_BASE_URL}/updateCard`, {
        method: 'POST',
        body: JSON.stringify({
          customer_info: this.basicCustomerInfo,
          subscription_id: this.subscription.id,
          customer_id: this.subscription.customer_id,
          card_number: this.cardNumber,
          exp_date: this.expDate,
          source: this.subscription.source,
          original_value: previousCardDetails,
          new_value: this.cardDetails,
        }),
      });

      const resObject = await res.json();

      if (resObject.status === 'fail') {
        this.errorMessage = 'Payment information failed to update.';
      } else {
        if (resObject.data.result == 'ERROR') {
          console.log(typeof resObject.data.message);
          if (typeof resObject.data.message == 'object') {
            for(const [key, message] of Object.entries(resObject.data.message)) {
              this.cardValidationError = `${key} ${message}`;
              break;
            }
          } else {
            this.cardValidationError = resObject.data.message;
          }
        } else {
          this.successMessage = 'Payment Information updated successfully.';

          this.resetForm();

          this.savingInProgress = false;
          this.editType = null;
        }
      }
    }
  }));

  Alpine.data('stripPayment', () => ({
    strip: null,
    cartHolderName: null,
    zipCode: null,
    stripDummy: null,
    stripElements: {
      cardNumber: {
        id: 'strip-payment-element-card-number',
        placeholder: 'Card Number',
        element: null,
        isComplete: false,
        error: null,
      },
      cardExpiry: {
        id: 'strip-payment-element-card-expiry',
        placeholder: 'Expiration Date',
        element: null,
        isComplete: false,
        error: null,
      },
      cardCvc: {
        id: 'strip-payment-element-card-cvc',
        placeholder: 'CVV',
        element: null,
        isComplete: false,
        error: null,
      },
    },
    cardValidationError: null,
    savingInProgress: false, 

    init() {
      this.initializeStrip();
    },

    closeEdit() {
      this.editType = null;
      this.resetForm();
    },

    resetForm() {
      this.cartHolderName = null;
      this.zipCode = null;
      this.cardValidationError = null;
    },

    initializeStrip() {
      
      const elementStyles = {};
    
      const elementClasses = {
        focus: 'focus',
        empty: 'empty',
        invalid: 'invalid',
      };

      this.stripe = Stripe(StripeAPIKey);
      const appearance = {};
      const options = {
        style: elementStyles,
        classes: elementClasses,
      };

      const elements = this.stripe.elements({ appearance });

      // this.stripDummy = elements.create('card', options);
      // this.stripDummy.mount('#strip-payment-element-card');

      for (const [elementKey, properties] of Object.entries(this.stripElements)) {
        properties.element = elements.create(elementKey, { ...options, placeholder: properties.placeholder });
        properties.element.mount('#'+properties.id);

        properties.element.on('change', (event) => {
          properties.isComplete = event.complete;
          properties.error = event.error;
        });
      }
    },
    get cardValidationError() {
      for (const stripElement of Object.values(this.stripElements)) {
        if (stripElement.error) {
          return stripElement.error.message;
        }
      }
    },
    get saveButttonEnabled() {
      // return true;
      return Object.values(this.stripElements).every(e => e.isComplete);
    },
    savePaymentInfo() {
      
      // Show loading
      this.savingInProgress = true;

      // this.stripe.createToken(this.stripDummy).then(async (result) => {
      this.stripe.createToken(this.stripElements.cardNumber.element).then(async (result) => {
        // Handle result.error or result.token
        console.log(result);

        if (result.error) {
          this.cardValidationError = result.error.message;
          this.savingInProgress = false;
        } else if(result.token) {
          this.cardValidationError = '';

          console.log(result);

          // const { processor_customer_token, processor_name, processor_payment_method_token, payment_details } = this.subscription.address_details.payment_method;
          const { processor_customer_token, processor_name, processor_payment_method_token, payment_details } = this.paymentMethod.recharge;

          const res = await fetch(`${STORE_BACKEND_BASE_URL}/addStripCard`, {
            method: 'POST',
            body: JSON.stringify({
              customer_info: this.basicCustomerInfo,
              subscription_id: this.subscription.id,
              customer_id: this.subscription.customer_id,
              address_id: this.subscription.address_id,
              strip_card_token: result.token.id,
              processor_customer_token,
              processor_name,
              processor_payment_method_token,
              original_value: payment_details,
            }),
          });

          const resObject = await res.json();
          console.log(resObject);

          if (resObject.status === 'fail') {
            this.errorMessage = 'Payment information failed to update.';
          } else {
            this.successMessage = 'Payment Information updated successfully.';
          }

          this.resetForm();

          this.savingInProgress = false;
          this.editType = null;
        }
      });
    }
  }));


  Alpine.data('inactive_subscription', (subscriptionId) => ({
    subscription: null,

    init() {
      if (!subscriptionId) {
        return null;
      }
      this.subscription = this.subscriptions.inactive.find((s) => s.id == subscriptionId);
      this.selectedShipmentDate = this.subscription.next_charge_scheduled_at.date;
    },

    get paymentBrandName() {
      if (!this.paymentMethod) {
        return null;
      }

      if (this.subscription.source === 'RECHARGE') {
        return this.subscription.address_details.payment_method.payment_details.brand;
      }

      return this.paymentMethod.cc.cardType;
    },
    get cardNumber() {
      if (!this.paymentMethod) {
        return null;
      }

      let last4 = null;

      if (this.subscription.source === 'RECHARGE') {
        const paymentData = this.subscription.address_details.payment_method.payment_details;
        last4 = paymentData.last4;
      } else {
        const paymentData = this.paymentMethod.cc;
        last4 = paymentData.cardLast4;
      }

      return last4;
    },
    get paymentDetails() {
      if (!this.paymentMethod) {
        return null;
      }

      let last4 = null;
      let expMonth = null;
      let expYear = null;

      if (this.subscription.source === 'RECHARGE') {
        const paymentData = this.subscription.address_details.payment_method.payment_details;
        last4 = paymentData.last4;
        expMonth = paymentData.exp_month;
        expYear = paymentData.exp_year;
      } else {
        const paymentData = this.paymentMethod.cc;
        last4 = paymentData.cardLast4;
        expMonth = paymentData.cardMonth;
        expYear = paymentData.cardYear;
      }
      const paymentMethodParts = [];
      paymentMethodParts.push(`Ending in ${last4}`);
      paymentMethodParts.push(`Expiration date: ${expMonth} / ${expYear}`);

      return paymentMethodParts.filter((a) => a).join('<br/>');
    },
    get notAMemberShipProduct() {
      return !this.subscription.product_title.includes('Membership');
    },
    get productTypeClass() {
      let productType = 'bibleBox';

      if (this.subscription.product_title.includes('BibleBox')) {
        productType = 'bibleBox';
      }

      if (this.subscription.product_title.includes('Sticker')) {
        productType = 'sticker';
      }

      if (this.subscription.product_title.includes('Membership')) {
        productType = 'membership';
      }

      return productType;
    },
    get shippingCustomerName() {
      if (!this.subscription) {
        return null;
      }

      const address = this.subscription.address_details;
      return `${address.first_name} ${address.last_name}`;
    },
    get shippingAddress() {

      if (!this.subscription) {
        return null;
      }

      const addressParts = [];
      const address = this.subscription.address_details;
      addressParts.push(address.address1);
      addressParts.push(address.address2);
      addressParts.push(`${address.city} ${address.province} ${address.zip}`);

      return addressParts.filter((a) => a).join('<br/>');
    },
    get shirtSize() {
      if (!this.subscription) {
        return null;
      }

      const variantTitleParts = this.subscription.variant_title.split('/');
      if (variantTitleParts.length > 0) {
        const sizeCode = variantTitleParts[0].trim();

        return sizeCode;
      }

      return '';
    },
    get shirtSizeLabel() {
      const sizeList = {
        'S': 'Small',
        'M': 'Medium',
        'L': 'Large',
      };

      return sizeList[this.shirtSize] ? sizeList[this.shirtSize] : this.shirtSize;
    },
  }));

  Alpine.data('shippingAddress', () => ({
    validationError: null,
    address1: '',
    address2: '',
    city: '',
    country: '',
    first_name: '',
    last_name: '',
    phone: '',
    province: '',
    zip: '',

    init() {
      this.resetForm();

      this.$watch('validationError', () => {
        setTimeout(() => {
          this.validationError = null;
        }, 5000);
      });
    },
    resetForm() {
      const address = this.subscription.address_details;

      this.address1 = address.address1;
      this.address2 = address.address2;
      this.city = address.city;
      this.country = address.country;
      this.first_name = address.first_name;
      this.last_name = address.last_name;
      this.phone = address.phone;
      this.province = address.province;
      this.zip = address.zip;
    },
    closeEdit() {
      this.editType = null;
      this.resetForm();
    },
    get activateSaveButton() {

      if (!this.subscription) {
        return false;
      }

      const address = this.subscription.address_details;
      return this.address1 != address.address1
        || this.address2 != address.address2
        || this.city != address.city
        || this.country != address.country
        || this.first_name != address.first_name
        || this.last_name != address.last_name
        || this.phone != address.phone
        || this.province != address.province
        || this.zip != address.zip;
    },
    saveShippingAddress() {

      const validationErrors = {
        first_name: 'First Name is required.',
        last_name: 'Last Name is required.',
        address1: 'Address 1 is required.',
        city: 'City Name is required.',
        province: 'State is required.',
        zip: 'Zipcode is required.',
      };

      for ([field, message] of Object.entries(validationErrors)) {
        // Check validation
        if (this[field].trim() == '') {
          this.validationError = message;
          return;
        }
      }

      const { first_name, last_name, address1, address2, city, province, zip, country, phone } = this;
      const newShippingAddress = { first_name, last_name, address1, address2, city, province, zip, country, phone };

      // this.isLoaded = false;

      fetch(`${STORE_BACKEND_BASE_URL}/updateShippingAddress`, {
        method: 'POST',
        body: JSON.stringify({
          customer_info: this.basicCustomerInfo,
          subscription_id: this.subscription.id,
          customer_id: this.subscription.customer_id,
          address_id: this.subscription.address_id,
          shipping_address: newShippingAddress,
          source: this.subscription.source,
          original_value: this.subscription.address_details,
          new_value: newShippingAddress,
        })
      })
      .then((r) => r.json())
      .then((res) => {

        if (res.status == 'success') {
          if (res.data.error) {
            const errors = Object.values(res.data.error);
            this.validationError = errors[0];
            return false;
          } else if (res.data.errors) {
            const errors = Object.values(res.data.errors);
            this.validationError = errors[0];
            return false;
          } else if (!res.data.address) {
            this.validationError = 'Error: Something went wrong, Please try again after sometime!';
            return false;
          } else {
            // console.log(res);
            this.successMessage = 'Shipping address updated successfully.';

            // Update address value except payment_method_id and payment_method
            const { payment_method_id, payment_method } = this.subscription.address_details;
            this.subscription.address_details = { ...res.data.address, payment_method_id, payment_method };
          }
        } else {
          this.errorMessage = 'Shipping Address failed to update.';
        }

        // this.isLoaded = true;
        this.editType = null;
      });
    }
  }));

  Alpine.data('cancellationSurveyForm', () => ({
    productId: null,
    questions: [],
    loading: true,
    primaryQuestion: null,
    primaryAnswer: '',
    secondaryQuestion: null,
    secondaryAnswerOther: null,
    secondaryAnswer: '',
    feedbackAnswer: '',
    displayPrimaryQuestion: true,
    error: '',

    init() {
      // Get product id based on backend database table subscription_cancellation_survey_products
      if (this.subscription.product_title.includes('BibleBox')) {
        this.productId = 1;
      }

      if (this.subscription.product_title.includes('Membership')) {
        this.productId = 3;
      }

      if (this.subscription.product_title.includes('Sticker')) {
        this.productId = 2;
      }

      // Load questions
      fetch(`${STORE_BACKEND_BASE_URL}/surveyquestions?product_id=${this.productId}`)
        .then((response) => response.json()) // convert to json
        .then((json) => {
          this.loading = false;

          this.questions = json.data;
          this.primaryQuestion = json.data[0];

          if (this.primaryQuestion.answer_type === 'MULTI_SELECT') {
            this.primaryAnswer = [];
          }
        });

      this.$watch('primaryAnswer', (newValue) => {
        if (newValue) {
          this.error = null;
        }

        const selectedOption = this.primaryQuestion.options.find((o) => o.id === newValue);

        this.secondaryAnswer = '';

        if (selectedOption && selectedOption.questions) {
          this.secondaryQuestion = selectedOption.questions;

          if (this.secondaryQuestion.answer_type === 'MULTI_SELECT') {
            this.secondaryAnswer = [];
          }

          this.displayPrimaryQuestion = false;
        } else {
          this.secondaryQuestion = null;
        }
      });

      this.$watch('primaryAnswer', (newValue) => {
        if (newValue) {
          this.error = null;

          if (!this.isSelectedOther) {
            // Reset 'Other' text
            this.secondaryAnswerOther = null;
          }
        }
      });
    },

    get isAllAnswered() {
      if (!this.secondaryQuestion) {
        return this.primaryAnswer;
      }

      return this.primaryAnswer && this.secondaryAnswer && this.secondaryAnswer.length > 0;
    },
    get isSelectedOther() {
      if (!this.secondaryAnswer || this.secondaryQuestion.answer_type === 'TEXT') {
        return false;
      }

      if (this.secondaryQuestion.answer_type === 'SINGLE_SELECT') {
        const selectedOption = this.secondaryQuestion.options.find((o) => o.id === this.secondaryAnswer);

        if (selectedOption.option_text === 'Other') {
          return true;
        }
      } else if (this.secondaryQuestion.answer_type === 'MULTI_SELECT') {
        return this.secondaryQuestion.options
          .filter((o) => this.secondaryAnswer.includes(o.id))
          .find((o) => o.option_text === 'Other');
      }

      return false;
    },

    getSurveyData(question, answer) {
      const survey = { question: question.question_text };
      if (question.answer_type === 'TEXT') {
        survey.answer = answer;
      } else if (question.answer_type === 'MULTI_SELECT') {
        // survey.answer = answer.join(', ');

        const selectedOptionTexts = question.options.filter((o) => answer.includes(o.id)).map((o) => o.option_text);
        survey.answer = selectedOptionTexts.join(', ');
        if (selectedOptionTexts.includes('Other')) {
          survey.answerOther = this.secondaryAnswerOther;
        }
      } else {
        const selectedOption = question.options.find((o) => o.id === answer);

        if (selectedOption) {
          survey.answer = selectedOption.option_text;

          if (selectedOption.option_text === 'Other') {
            survey.answerOther = this.secondaryAnswerOther;
          }
        }
      }

      return survey;
    },
    async saveSurveyAndCancelSubscription() {
      // validate form
      if (this.primaryQuestion.answer_type !== 'TEXT' && !this.primaryAnswer) {
        this.error = 'Please answer all the questions!';
      }

      if (this.secondaryQuestion && this.secondaryQuestion.answer_type !== 'TEXT' && !this.secondaryAnswer) {
        this.error = 'Please answer all the questions!';
      }

      if (this.error) {
        return;
      }

      const surveyData = [];
      if (this.primaryQuestion) {
        surveyData.push(this.getSurveyData(this.primaryQuestion, this.primaryAnswer));
      }

      if (this.secondaryQuestion) {
        surveyData.push(this.getSurveyData(this.secondaryQuestion, this.secondaryAnswer));
      }

      const survey = { question: 'Feedback', answer: this.feedbackAnswer };
      surveyData.push(survey);

      const userSelections = {
        product_id: this.productId,
        primary_answer_id: this.primaryAnswer,
        secondary_answer_id: null,
        secondary_answer_text: null,
      };

      if (this.secondaryQuestion.answer_type === 'TEXT') {
        userSelections.secondary_answer_text = this.secondaryAnswer;
      } else if (this.secondaryQuestion.answer_type === 'MULTI_SELECT') {
        userSelections.secondary_answer_text = this.secondaryAnswer.join(', ');
      } else {
        userSelections.secondary_answer_id = this.secondaryAnswer;
      }

      console.log('surveyData: ');
      console.log(surveyData);

      console.log('userSelections: ');
      console.log(userSelections);

      const r = await fetch(`${STORE_BACKEND_BASE_URL}/cancelSubscription`, {
        method: 'POST',
        body: JSON.stringify({
          customer_info: this.basicCustomerInfo,
          subscription_id: this.subscription.id,
          source: this.subscription.source,
          surveyData,
          userSelections,
        }),
      });
  
      const res = await r.json();
      if (res.status == 'success') {
        // console.log(res);
        this.successMessage = 'Subscription cancelled successfully.';

        // Reactivate body scrolls
        Alpine.store('screen').isScrollableBody = true;

        this.selectedSubscriptionId = null;
        this.loadSubscriptions();
      } else {
        this.errorMessage = 'Error while cancelling subscription!';
      }
    },
  }));
});